import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {
  SecondaryLinksSEO,
  SecondaryNavigationEvent
} from './models/secondary-links-seo.interfaces';

@Component({
  selector: 'idp-app-sec-links-seo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './secondary-links-seo.component.html',
  styleUrls: ['./secondary-links-seo.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SecondaryLinksSeoComponent implements OnChanges {
  @Input() content: SecondaryLinksSEO = {} as SecondaryLinksSEO;
  @Input() isMobile = false;
  @Input() navigationId = '';
  @Input() isAlertAdvisory = false;
  @Output() analyticsEvent = new EventEmitter<SecondaryNavigationEvent>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['navigationId']) {
      this.navigationId = changes['navigationId'].currentValue;
    }
  }

  checkMainNavigationContent(): boolean {
    return (
      this.content &&
      this.content.details &&
      this.content.details.mainNavigation.length > 0
    );
  }

  setTrackingObject(id: string, brandLabel: string, url: string): void {
    this.analyticsEvent.emit({ id, brandLabel, url });
  }

  onKeyPress(e: KeyboardEvent | HTMLElement | Event): void {
    if (!(e instanceof KeyboardEvent)) {
      return;
    }

    const target = e.target as HTMLElement;

    if (!target?.parentElement) {
      return;
    }

    const navigationMap = {
      ArrowDown: target.parentElement.nextElementSibling?.firstChild,
      ArrowUp: target.parentElement.previousElementSibling?.firstChild
    };

    const elementToFocus = navigationMap[e.key as keyof typeof navigationMap];

    if (elementToFocus) {
      e.preventDefault();
      (elementToFocus as HTMLElement).focus();
    }
  }
}
